<template>
  <transition name="fade">
    <div v-if="open" class="notification-modal-backdrop" @click="close">
      <div class="notification-modal" @click.stop>
        <div class="notification-modal-header">
          <h2>Уведомления. ({{ notifications.length }})</h2>
          <button @click="close" class="close-button">&times;</button>
        </div>
        <div class="notification-modal-body" v-if="notifications.length > 0">
          <div class="notification-modal-body-item" v-for="notification in notifications" :key="notification.id">
              <p>{{notification.message}}</p>
          </div>
        </div>
        <div class="notification-modal-body" v-else>
          <p>У вас нет новых уведомлений.</p>
        </div>
        <div class="notification-modal-footer">
          <button class="notification-modal-footer-button" @click="readAllNotifications">Прочитано</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    notifications: {
      type: Array,
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close', 'readAllNotifications'],
  methods: {
    close() {
      this.$emit('close');
    },
    readAllNotifications(){
      this.$emit('readAllNotifications');
    }
  },
  watch: {
    open(isOpen) {
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  mounted() {
    const handleKeyup = (event) => {
      if (event.keyCode === 27 && this.open) {
        this.close();
      }
    };
    document.addEventListener("keyup", handleKeyup);
    this.$once('hook:beforeDestroy', () => {
        document.removeEventListener('keyup', handleKeyup);
    });
  },
};
</script>

<style lang="scss" scoped>
.notification-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.notification-modal {
  background: #F4F4F8;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  max-height: 60%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow-x: auto;
}

.notification-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  background: #fff;
  padding: 10px 20px;
  margin-bottom: 20px;
  border-radius: 10px 10px 0 0;
}

.notification-modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
}

.close-button {
  border: none;
  background: transparent;
  font-size: 2rem;
  cursor: pointer;
  color: #818181;
}

.notification-modal-body {
  width: 93%;
  margin: 0 auto;
  &-item{
    padding: 10px 10px;
    background: #fff;
    margin-bottom: 25px;
    border-radius: 8px;
    p{
      margin: 0;
    }
  }
  /* Notifications will be listed here */
}
.notification-modal-footer{
  width: 100%;
  display: flex;
  justify-content: center;
}
.notification-modal-footer-button{
  width: 93%;
  background: #007BFF;
  border-radius: 8px;
  border: none;
  padding: 10px 10px;
  color: #fff;
  font-size: 1.2rem;
  cursor: pointer;
  margin: 0 auto 25px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style> 